import _objectSpread from "@babel/runtime/helpers/objectSpread2";
//@ts-check
import React from "react";
import classnames from "../util/classnames";
import { Dummy } from "../media/Image";

// port of the trivia/default.ctp
// note reveal is not implemented yet.
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var defaults = {
  className: "",
  thumbnailEnabled: true,
  thumbnailTitle: null,
  thumbnail: null,
  dummy: null,
  icon: null,
  link: null,
  linkTarget: "_blank",
  header: "",
  headerBottom: false,
  body: "",
  revealEnabled: false,
  revealBody: null,
  revealLinkText: null
};

/**
 * a simple php-like check to see if there is content.
 * uses the length function (compatible with string and arrays)
 * @param {string|[]} c
 * @returns {boolean}
 */
var empty = function empty(c) {
  return c !== null && c !== undefined && (!c.length || c.length > 0);
};
/**
 * checks if the reveal functionality should take over instaed of the link behavior
 */
var isRevealEnabled = function isRevealEnabled(_ref) {
  var revealEnabled = _ref.revealEnabled,
    link = _ref.link,
    revealBody = _ref.revealBody,
    revealLinkText = _ref.revealLinkText;
  return revealEnabled && link && (!empty(revealBody) || !empty(revealLinkText));
};
/**
 * checks if we should show the thumbnail or icon element
 */
var isThumbnailEnabled = function isThumbnailEnabled(_ref2) {
  var thumbnailEnabled = _ref2.thumbnailEnabled,
    thumbnail = _ref2.thumbnail,
    icon = _ref2.icon;
  return thumbnailEnabled && (thumbnail || icon);
};

/**
 * if link is available, and reveal is disabled, it wrapps all the component
 * with a link, otherwise it wrapps a simple div
 */
var LinkWrapper = function LinkWrapper(_ref3) {
  var link = _ref3.link,
    revealEnabled = _ref3.revealEnabled,
    className = _ref3.className,
    children = _ref3.children;
  return link && !revealEnabled ? /*#__PURE__*/_jsx("a", {
    className: className,
    href: link,
    children: children
  }) : /*#__PURE__*/_jsx("div", {
    className: className,
    children: children
  });
};

// If thumbnail is a Icon, this component is used
var Icon = function Icon(_ref4) {
  var className = _ref4.className;
  if (className.indexOf("glyphicon") === -1) {
    className = "mbicon mbicon-".concat(className);
  }
  return /*#__PURE__*/_jsx("i", {
    className: className,
    style: {
      fontSize: "25px"
    }
  });
};

// if thumbnail is a image, this comonent is used
var Image = function Image(_ref5) {
  var src = _ref5.src,
    dummy = _ref5.dummy,
    title = _ref5.title,
    style = _ref5.style;
  return /*#__PURE__*/_jsx(Dummy, {
    style: style,
    className: "img-circle",
    src: src,
    dummy: dummy,
    title: title,
    alt: title
  });
};

// wrapps Icon or Image into a Thumbnail
var ThumbWrapper = function ThumbWrapper(props) {
  return /*#__PURE__*/_jsx("figure", _objectSpread(_objectSpread({}, props), {}, {
    className: classnames("list-group-item-media-thumbnail", props)
  }));
};
var Header = function Header(props) {
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    className: classnames("list-group-item-media-header", props)
  }));
};

// used as default function in DefaultTrivia, can there be overriden
var Content = function Content(props) {
  return props.children;
};
var Thumbnail = function Thumbnail(_ref6) {
  var thumbnailEnabled = _ref6.thumbnailEnabled,
    thumbnailTitle = _ref6.thumbnailTitle,
    thumbnail = _ref6.thumbnail,
    dummy = _ref6.dummy,
    icon = _ref6.icon,
    _ref6$thumbnailStyle = _ref6.thumbnailStyle,
    thumbnailStyle = _ref6$thumbnailStyle === void 0 ? {
      width: "25px"
    } : _ref6$thumbnailStyle;
  return !isThumbnailEnabled({
    icon: icon,
    thumbnail: thumbnail,
    thumbnailEnabled: thumbnailEnabled
  }) ? null : /*#__PURE__*/_jsx(ThumbWrapper, {
    children: icon ? /*#__PURE__*/_jsx(Icon, {
      className: icon
    }) : /*#__PURE__*/_jsx(Image, {
      src: thumbnail,
      dummy: dummy,
      title: thumbnailTitle,
      style: thumbnailStyle
    })
  });
};

/**
 *
 * @param {import("./defineTrivia").CommonTriviaProps & {ContentComponent?: () => JSX.Element, children?: any}} props
 */
export default function DefaultTrivia(props) {
  var _props = props = _objectSpread(_objectSpread({}, defaults), props),
    className = _props.className,
    link = _props.link,
    header = _props.header,
    headerBottom = _props.headerBottom,
    body = _props.body,
    children = _props.children,
    _props$ContentCompone = _props.ContentComponent,
    ContentComponent = _props$ContentCompone === void 0 ? Content : _props$ContentCompone;
  if (children) {
    body = children;
  }
  var thumbnailElement = /*#__PURE__*/_jsx(Thumbnail, _objectSpread({}, props));
  var headerElement = header ? /*#__PURE__*/_jsx(Header, {
    children: header
  }) : null;
  var contentElement = /*#__PURE__*/_jsx(ContentComponent, {
    children: headerBottom ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [body, thumbnailElement, headerElement]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [thumbnailElement, headerElement, body]
    })
  });
  return /*#__PURE__*/_jsx(LinkWrapper, {
    className: classnames(className, "list-group-item list-group-item-media"),
    link: link,
    revealEnabled: false,
    children: contentElement
  });
}
//# sourceMappingURL=DefaultTrivia.js.map